<div class="car-page">

    <!-- ── Loading bar ──────────────────────────────── -->
    <ng-template #attente>
        <div class="car-progress-bar">
            <div class="car-progress-bar__inner"></div>
        </div>
    </ng-template>
    <div *ngIf="enregistrementTerminer; else attente"></div>

    <!-- ── Page header ──────────────────────────────── -->
    <header class="car-page__header pb-4">
        <h1 class="car-page__title">
            <span class="car-page__title-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                    <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2" />
                    <rect x="9" y="3" width="6" height="4" rx="1" />
                </svg>
            </span>
            Caractéristiques
        </h1>
        <p class="car-page__subtitle">Gérer les caractéristiques</p>
    </header>

    <!-- ── Two-column layout ────────────────────────── -->
    <div class="car-grid">

        <!-- ══ LEFT PANEL ══ -->
        <section class="car-panel">

            <div class="car-panel__header">
                <span class="car-panel__icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2.2">
                        <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2" />
                        <rect x="9" y="3" width="6" height="4" rx="1" />
                    </svg>
                </span>
                Caractéristiques
            </div>

            <div class="car-panel__body">
                <form #f="ngForm" (ngSubmit)="ajouter(f)">

                    <!-- Modèle searchable dropdown (your custom component) -->
                    <div class="car-field car-field--full">
                        <app-searchable-dropdown [items]="listeCaracteristiqueModelAll" [labelKey]="'ecArtCarMod_Label'"
                            [placeholder]="'Modèle *'"
                            (select)="categorieModelSelected = $event.ecArtCarMod_Id; caracteristiqueModelSelected($event)">
                        </app-searchable-dropdown>
                    </div>

                    <!-- Désignation + Filtre + Ajouter -->
                    <div class="car-form-row">

                        <div class="car-field car-field--grow">
                            <label class="car-label">Désignation</label>
                            <input class="car-input" type="text" [disabled]="disabled" name="ecArtCar_Label"
                                #ecArtCar_Label="ngModel" [(ngModel)]="caracteristique.ecArtCar_Label"
                                placeholder="Désignation caractéristique" required />
                        </div>

                        <label class="car-toggle">
                            <input type="checkbox" [disabled]="disabled" name="ecArtCarModFiltre"
                                [(ngModel)]="caracteristique.ecArtCarMod_Filtre" />
                            <span class="car-toggle__track"></span>
                            <span class="car-toggle__text">Filtre</span>
                        </label>

                        <button type="submit" [disabled]="disabled" class="car-btn car-btn--primary">
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2.8">
                                <line x1="12" y1="5" x2="12" y2="19" />
                                <line x1="5" y1="12" x2="19" y2="12" />
                            </svg>
                            Ajouter
                        </button>

                    </div>
                </form>

                <!-- Search + Delete toolbar -->
                <div class="car-toolbar">
                    <div class="car-search">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <circle cx="11" cy="11" r="8" />
                            <line x1="21" y1="21" x2="16.65" y2="16.65" />
                        </svg>
                        <input class="car-search__input" type="text" (keyup)="applyFilter($event.target.value)"
                            placeholder="Rechercher…" />
                    </div>
                    <button [disabled]="disabledBtnSupprimer" (click)="supprimer()"
                        class="car-btn car-btn--danger car-btn--sm">
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <polyline points="3 6 5 6 21 6" />
                            <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6" />
                            <path d="M10 11v6M14 11v6" />
                            <path d="M9 6V4h6v2" />
                        </svg>
                        Supprimer
                    </button>
                </div>

                <!-- Pure HTML table — no mat-table -->
                <div class="car-table-wrap">
                    <table class="car-table">
                        <thead>
                            <tr>
                                <th>Code</th>
                                <th>Texte</th>
                                <th class="center">Filtre</th>
                                <th class="center">Ordre</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let element of dataSource.data ?? dataSource"
                                (click)="selectRow($event, element)" [class.selected]="element === rowSelected">
                                <td class="code">{{ element.ecArtCar_Id }}</td>
                                <td>
                                    <input class="car-input car-input--ghost" type="text" (blur)="modifier(element)"
                                        [name]="'caracteristiqueText2' + element.ecArtCar_Id"
                                        [(ngModel)]="element.ecArtCar_Label" />
                                </td>
                                <td class="center">
                                    <label class="car-toggle car-toggle--sm">
                                        <input type="checkbox" name="ecArtCarMod_Filtre" (change)="modifier(element)"
                                            [(ngModel)]="element.ecArtCarMod_Filtre" />
                                        <span class="car-toggle__track"></span>
                                    </label>
                                </td>
                                <td class="center">
                                    <input class="car-input car-input--order" type="text" (blur)="modifier(element)"
                                        [name]="'ecArtCarMod_Ordre' + element.ecArtCar_Id"
                                        [(ngModel)]="element.ecArtCarMod_Ordre" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </section>

        <!-- ══ RIGHT PANEL ══ -->
        <section class="car-panel">

            <div class="car-panel__header">
                <span class="car-panel__icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2.2">
                        <path d="M4 6h16M4 10h16M4 14h10" />
                    </svg>
                </span>
                Valeurs
            </div>

            <div class="car-panel__body">
                <form #formValue="ngForm" (ngSubmit)="ajouterCaracteristiqueValue(formValue)">
                    <div class="car-form-row">

                        <div class="car-field car-field--grow">
                            <label class="car-label">Désignation</label>
                            <input class="car-input" type="text" [disabled]="disabled" name="ecArtCarValList_Label"
                                #ecArtCarValList_Label="ngModel"
                                [(ngModel)]="caracteristiqueValue.ecArtCarValList_Label"
                                placeholder="Désignation valeur" required />
                        </div>

                        <button type="submit" [disabled]="disabled" class="car-btn car-btn--primary">
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2.8">
                                <line x1="12" y1="5" x2="12" y2="19" />
                                <line x1="5" y1="12" x2="19" y2="12" />
                            </svg>
                            Ajouter
                        </button>

                    </div>
                </form>

                <app-liste [showFilter]="false" [heightTable]="'400'" [dataSourceBrut]="datasourceCarcarteristiqueValue"
                    [displayedColumnsBrut]="columnsCarcarteristiqueValue" [listBtn]="listBtnCarcarteristiqueValue"
                    (btnTable)="clickBtnHeat($event)" (blurInp)="onInput($event)">
                </app-liste>

            </div>
        </section>

    </div>
</div>